import { rolesUsersRoutes } from "./utils/constants";

export const routes = {
    change_password: {
        path: '/admin/change-password'
    },
    setup_2fa: {
        path: '/admin/2fa'
    },
    centros: {
        path: '/admin/centros',
        requiredRoles: [String(rolesUsersRoutes.superadmin)]
    },
    new_centro: {
        path: '/admin/new-centro',
        requiredRoles: [String(rolesUsersRoutes.superadmin)]
    },
    edit_centro: {
        path: '/admin/centros/:id',
        requiredRoles: [String(rolesUsersRoutes.superadmin)]
    },
    centro_profesionales: {
        path: '/admin/centros/:id/profesionales',
        requiredRoles: [String(rolesUsersRoutes.superadmin)]
    },
    users: {
        path: '/admin/users',
        requiredRoles: [String(rolesUsersRoutes.superadmin)]
    },
    new_user: {
        path: '/admin/new-user',
        requiredRoles: []
    },
    edit_user: {
        path: '/admin/users/:public_id',
        requiredRoles: [String(rolesUsersRoutes.superadmin)]
    },
    edit_user_password: {
        path: '/admin/users/:public_id/changePass',
        requiredRoles: [String(rolesUsersRoutes.superadmin),String(rolesUsersRoutes.administrador)]
    },
    administrativos: {
        path: '/admin/administrativos',
        requiredRoles: [String(rolesUsersRoutes.administrador)]
    },
    new_administrativo: {
        path: '/admin/new-administrativo',
        requiredRoles: [String(rolesUsersRoutes.administrador)]
    },
    edit_administrativo: {
        path: '/admin/administrativos/:public_id',
        requiredRoles: [String(rolesUsersRoutes.administrador)]
    },
    profesionales: {
        path: '/admin/professionals',
        requiredRoles: [String(rolesUsersRoutes.administrador), String(rolesUsersRoutes.administrativo)]
    },
    new_profesional: {
        path: '/admin/new-professional',
        requiredRoles: [String(rolesUsersRoutes.administrador), String(rolesUsersRoutes.administrativo)]
    },
    edit_profesional: {
        path: '/admin/professionals/:public_id',
        requiredRoles: [String(rolesUsersRoutes.administrador), String(rolesUsersRoutes.administrativo)]
    },
    pacientes: {
        path: '/admin/patients',
        requiredRoles: [String(rolesUsersRoutes.administrador), String(rolesUsersRoutes.administrativo),String(rolesUsersRoutes.profesional)]
    },
    new_paciente: {
        path: '/admin/new-patient',
        requiredRoles: [String(rolesUsersRoutes.administrador), String(rolesUsersRoutes.administrativo),String(rolesUsersRoutes.profesional)]
    },
    edit_paciente: {
        path: '/admin/patients/:id',
        requiredRoles: [String(rolesUsersRoutes.administrador), String(rolesUsersRoutes.administrativo),String(rolesUsersRoutes.profesional)]
    },
    show_paciente: {
        path: '/admin/patients/show/:id',
        requiredRoles: [String(rolesUsersRoutes.administrador), String(rolesUsersRoutes.administrativo),String(rolesUsersRoutes.profesional)]
    },
    new_informe: {
        // administrativo excluido: todo informe/certificado requiere firma del
        // profesional, no debe poder emitirlo ni ver los ya emitidos.
        path: '/admin/patients/:id/informes/:tipo/new',
        requiredRoles: [String(rolesUsersRoutes.administrador), String(rolesUsersRoutes.profesional)]
    },
    edit_informe: {
        path: '/admin/patients/:id/informes/:tipo/:informeId',
        requiredRoles: [String(rolesUsersRoutes.administrador), String(rolesUsersRoutes.profesional)]
    },
    show_paciente_info_sensible: {
        requiredRoles: [String(rolesUsersRoutes.administrador), String(rolesUsersRoutes.profesional)]
    },
    historia_clinica_psiquiatrica: {
        path: '/admin/patients/:id/historia-clinica',
        requiredRoles: [String(rolesUsersRoutes.administrador), String(rolesUsersRoutes.profesional)]
    },
    genograma: {
        path: '/admin/patients/:id/genograma',
        requiredRoles: [String(rolesUsersRoutes.administrador), String(rolesUsersRoutes.profesional)]
    },
    patient_personalinfo: {
        path: '/admin/patient-info-personal',
        requiredRoles: [String(rolesUsersRoutes.paciente)]
    },
    farmacos: {
        path: '/admin/farmacos',
        requiredRoles: [String(rolesUsersRoutes.administrador),String(rolesUsersRoutes.profesional)]
    },
    new_farmaco: {
        path: '/admin/new-farmaco',
        requiredRoles: [String(rolesUsersRoutes.administrador),String(rolesUsersRoutes.profesional)]
    },
    edit_farmaco: {
        path: '/admin/farmacos/:id',
        requiredRoles: [String(rolesUsersRoutes.administrador),String(rolesUsersRoutes.profesional)]
    },
    examenes: {
        path: '/admin/examens',
        requiredRoles: [String(rolesUsersRoutes.administrador), String(rolesUsersRoutes.profesional)]
    },
    new_examen: {
        path: '/admin/new-examen',
        requiredRoles: [String(rolesUsersRoutes.administrador), String(rolesUsersRoutes.profesional)]
    },
    edit_examen: {
        path: '/admin/examens/:id',
        requiredRoles: [String(rolesUsersRoutes.administrador), String(rolesUsersRoutes.profesional)]
    },
    diagnosticos: {
        path: '/admin/diagnostics',
        requiredRoles: [String(rolesUsersRoutes.administrador), String(rolesUsersRoutes.profesional)]
    },
    new_diagnostico: {
        path: '/admin/new-diagnostic',
        requiredRoles: [String(rolesUsersRoutes.administrador), String(rolesUsersRoutes.profesional)]
    },
    edit_diagnostico: {
        path: '/admin/diagnostics/:id',
        requiredRoles: [String(rolesUsersRoutes.administrador), String(rolesUsersRoutes.profesional)]
    },
    new_consulta: {
        path: '/admin/new-consulta',
        requiredRoles: [String(rolesUsersRoutes.profesional)]
    },
    new_consulta_form: {
        path: '/admin/new-consulta/:idPatient',
        requiredRoles: [String(rolesUsersRoutes.profesional)]
    },
    videoconsulta: {
        path: '/admin/videoconsulta/:idPatient',
        // Sin `paciente`: el paciente entra por el enlace público de "Mi cita"
        // (PatientVideoJoin), no con cuenta. Hoy ni siquiera se le crea una
        // -esta comentado en pacient_service.py-, asi que este camino no lo
        // recorria nadie, pero seguia abierto y con tres fallas propias.
        // ANTES DE VOLVER A PONER `paciente` AQUI hay que arreglarlas, porque
        // ninguna se nota mirando la pantalla:
        //   1. denegar no encuentra la fila del paciente CON cuenta (la busca
        //      con user_id NULL) y devuelve 200 igual: el profesional lee
        //      "listo" y no se escribio ni denegado_at ni el evento.
        //   2. _sala_status no emite `denied`, asi que aunque se denegara, esa
        //      pantalla se queda esperando para siempre.
        //   3. su `admitted` es de la sala y no del participante: admitido uno,
        //      el resto de la fila entra solo.
        // Las tres estan resueltas en el camino del enlace y solo ahi.
        requiredRoles: [String(rolesUsersRoutes.administrador), String(rolesUsersRoutes.profesional)]
    },
    export_patient_info_personal: {
        requiredRoles: [String(rolesUsersRoutes.administrador)]
    },
    export_patient_ficha_consultas: {
        requiredRoles: [String(rolesUsersRoutes.administrador)]
    },
    export_patient_pdf: {
        requiredRoles: [String(rolesUsersRoutes.administrador),String(rolesUsersRoutes.profesional)]
    },
    calendar:{
        path: '/admin/calendar',
        requiredRoles: [String(rolesUsersRoutes.administrador), String(rolesUsersRoutes.profesional), String(rolesUsersRoutes.administrativo)]
    },
    configuracion: {
        path: '/admin/configuracion',
        requiredRoles: [String(rolesUsersRoutes.administrador), String(rolesUsersRoutes.profesional)]
    },
    horarios_trabajo: {
        path: '/admin/horarios-trabajo',
        requiredRoles: [String(rolesUsersRoutes.profesional)]
    },
    logs: {
        path: '/admin/logs',
        requiredRoles: [String(rolesUsersRoutes.administrador)]
    },
    dashboard: {
        path: '/admin/dashboard',
        requiredRoles: [String(rolesUsersRoutes.profesional), String(rolesUsersRoutes.administrador), String(rolesUsersRoutes.administrativo)]
    },

}

export const redirectLoggedUserDefault = {
    'superadmin': routes.users.path,
    'administrador': routes.administrativos.path,
    'administrativo': routes.pacientes.path,
    'profesional': routes.dashboard.path,
    'paciente': routes.patient_personalinfo.path,
    'calendar': routes.calendar.path,
    'configuracion': routes.configuracion.path
}
